import React, { useEffect, useState } from 'react'
import {
  Box,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Select,
  TextField,
  MenuItem,
  Dialog,
  DialogContent,
  IconButton
} from '@mui/material'
import {
  ApiGetShopper,
  ApiGetNearbyShopper,
  ApiPostInviteShopper,
  ApiGetShopperList,
  ApiCriteriaMessage
} from '../../../apiService/Core/Apicall.tsx'
import { toast } from 'react-toastify'
import { CancelOutlined } from '@mui/icons-material'

const withinData = [
  { label: 'Within 10 km', value: '10km' },
  { label: 'Within 25 km', value: '25km' },
  { label: 'Within 50 km', value: '50km' },
  { label: 'Within 150 km', value: '150km' }
]

const InviteShopper = () => {

  const [values, setValues] = useState<{ oldShopperIds: string[] }>({
    oldShopperIds: []
  })
  const [shopperList, setShopperList] = useState<any>([])
  const [stateData, setStateData] = useState<any>(null)
  const [searchQuery, setSearchQuery] = useState('')
  const [gender, setGender] = useState<any>('')
  const [startAge, setStartAge] = useState('')
  const [age, setAge] = useState('')
  const [selectedDistance, setSelectedDistance] = useState<string>("")
  const [errorMessages, seterrorMessages] = useState<any>([])
  const [iserror, setiserror] = useState<boolean>(false)

  // console.log("Selected SHooper", values)
  // console.log("Selected dtaa", stateData)
  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    setValues(prevValues => ({
      oldShopperIds: event.target.checked
        ? [...prevValues.oldShopperIds, value]
        : prevValues.oldShopperIds.filter(val => val !== value)
    }))
  }
  useEffect(() => {
    if (gender && startAge && age && stateData) {
      const fetchData = async () => {
        await ApiCallGetShopperList()
      }
      fetchData()
    }
    return () => { }
  }, [gender, startAge, age, stateData, selectedDistance])
  const ApiCallGetShopperList = async () => {

    const data = `?offset=0&limit=500&status=active&gender=${gender}&minAge=${startAge}&maxAge=${age}${selectedDistance && `&latitude=${stateData?.venueId.lat}&longitude=${stateData?.venueId.lat}&kilometerRange=${selectedDistance}`}`
    const res = await ApiGetShopperList(data)
    // const response = res?.data.map(item => ({
    //   label:
    //     item.firstName + item.lastName === ''
    //       ? '-'
    //       : item.firstName + item.lastName,
    //   value: item.userId
    // }))
    const response = res?.data
      .filter(item => item.firstName.trim() !== '' && item.lastName.trim() !== '')
      .map(item => {
        const dob = new Date(item.dob); // assuming item.dob exists and is a valid date string
        const today = new Date();
        let age = today.getFullYear() - dob.getFullYear();
        const m = today.getMonth() - dob.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
          age--;
        }

        return {
          label: `${item.firstName} ${item.lastName}`,
          value: item.userId,
          emailId: item.emailId,
          age: age, // calculated from dob
        };
      });

    setShopperList(response);

  }

  const handleDistanceChange = (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
    if (event.target.checked) {
      setSelectedDistance(value)
      // Here you would typically call an API to get shoppers within this distance
      //fetchNearbyShoppers(value)
    } else {
      setSelectedDistance("")
    }
  }


  useEffect(() => {
    const storedDataUp = sessionStorage.getItem('inviteShopperState')
    if (storedDataUp) {
      setStateData(JSON.parse(storedDataUp))
    }
  }, [])

  useEffect(() => {
    setGender(stateData?.gender || '')
    setStartAge(stateData?.minAge || '')
    setAge(stateData?.maxAge || '')
  }, [stateData])

  const filteredVenues = shopperList.filter(option =>
    option.label.toLowerCase().includes(searchQuery.toLowerCase())
  )

  const handleSendInviteToShopper = async () => {
    const data = {
      userIds: values.oldShopperIds,
      allocationId: stateData?.allocationId,
      createdBy: Number(localStorage.getItem('createdBy')),
    }
    if (errorMessages.length <= 0) {
      alert("Call APi")

    }
    try {
      const response = await ApiPostInviteShopper(data)
      toast.success('Selected Shoppers Invited Successfully!')
    }
    catch (error) {
      console.error('Error updating store:', error)
      toast.error(error);
    }
  }
  const handlecriteriamessage = async () => {
    seterrorMessages([])
    if (errorMessages.length <= 0) {
      const data = `?userId=${values.oldShopperIds.join(',')}&allocationId=${stateData.allocationId}&clientEntityId=${stateData.venueId.clientEntityId.clientEntityId}`
      try {
        const response = await ApiCriteriaMessage(data)
        console.log(response.data)
        const tempErrors: any = [];
        response.data.map((item, index) => {
          if (item.allocationCriteriaFailures.length > 0) {
            tempErrors.push({

              username: item.username,
              messages: item.allocationCriteriaFailures

            })
          }
        })
        seterrorMessages(tempErrors)
        if (tempErrors.length <= 0) { handleSendInviteToShopper() }
      }
      catch (error) {
        console.error('Error updating store:', error)
        toast.error(error);
      }

    }
  }


  useEffect(() => {
    errorMessages.length > 0 ? setiserror(true) : setiserror(false)
  }, [errorMessages])
  return (
    <div className='invite-shopper'>
      <h1 className='common-add' style={{ textAlign: 'center' }}>
        Orphan Allocation - Invite-Shopper
      </h1>
      <div>
        <Typography variant='h6' gutterBottom>
          {stateData?.venueId?.venueName}
        </Typography>
        <Typography>
          <b>Address:</b> {stateData?.venueId.address}
        </Typography>
        <Typography>
          <b>Postcode:</b> {stateData?.venueId?.postalCode}
        </Typography>
        <Typography>
          <b>Trade House:</b> {stateData?.venueId?.tradingHours}
        </Typography>
        <Typography>
          <b>WebSite:</b>
          <a href={stateData?.venueId?.websiteURL}>
            {stateData?.venueId?.websiteURL}
          </a>
        </Typography>
        <hr />
        <div>
          {withinData.map((option) => (
            <FormControlLabel
              key={option.value}
              control={
                <Checkbox
                  checked={selectedDistance === option.value}
                  onChange={(event) => handleDistanceChange(event, option.value)}
                />
              }
              label={option.label}
            />
          ))}
        </div>
        <hr />
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <div className='flex items-center gap-2'>
            <span>Start Age: </span>
            <Select
              value={startAge}
              onChange={e => setStartAge(e.target.value)}
            >
              {Array.from({ length: 86 }, (_, i) => (i + 15).toString()).map(
                age => (
                  <MenuItem key={age} value={age}>
                    {age}
                  </MenuItem>
                )
              )}
            </Select>
          </div>

          <div className='flex items-center gap-2'>
            <span>End Age: </span>
            <Select value={age} onChange={e => setAge(e.target.value)}>
              {Array.from({ length: 86 }, (_, i) => (i + 15).toString()).map(
                ageOption => (
                  <MenuItem key={ageOption} value={ageOption}>
                    {ageOption}
                  </MenuItem>
                )
              )}
            </Select>
          </div>
          <div className='flex items-center gap-2'>
            <span>Gender: </span>
            <Select
              value={gender}
              onChange={e => setGender(e.target.value)}
              style={{ width: '150px' }}
            >
              <MenuItem value='Female'>Female</MenuItem>
              <MenuItem value='Male'>Male</MenuItem>
              <MenuItem value='All'>All</MenuItem>
            </Select>
          </div>
        </div>
        <hr />
        <TextField
          fullWidth
          type='text'
          InputLabelProps={{ shrink: true }}
          placeholder='Search Shopper...'
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
        />

        <hr />
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            Please Select Shopper (Shoppername) (Age) (Distance)
            <Button
              variant='contained'
              color='primary'
              size='small'
              className='table-row-background'
              style={{ marginBottom: '0px', width: '200px' }}
              // onClick={handleSendInviteToShopper}
              onClick={handlecriteriamessage}
            >
              Invite Shopper Select
            </Button>
          </div>
          <hr />
          <Box className='d-flex align-items-stretch justify-content-start flex-wrap' gap={1}>
            {filteredVenues.map(option => (
              <Box className='border d-flex align-items-start  px-2 py-2' gap={1} width='24%' borderRadius='10px' >
                <Checkbox
                  className='m-0 mb-0 pb-0'
                  checked={values.oldShopperIds.includes(option.value)}
                  onChange={event => handleCheckboxChange(event, option.value)}
                />
                <Box>
                  <Typography fontWeight='bold' whiteSpace='wrap' variant='subtitle2'>{option.label} ({option.age})</Typography>
                  <Typography className='' variant='subtitle2'>{option.emailId}</Typography>
                  {/* <Typography className=''  variant='subtitle2'></Typography> */}
                </Box>
              </Box>

            ))}
          </Box>
        </div>
      </div>
      {errorMessages.length > 0 && (
        <Dialog open={iserror}>
          <DialogContent>
            <Box className='d-flex mb- p-0 align-items-center mb-3' gap={5}>
              <Typography className='text-center text-danger' fontWeight='bold' variant='h5'>Error Reasons</Typography>
              <IconButton onClick={() => {
                setiserror(false); setValues({
                  oldShopperIds: []
                })
              }}><CancelOutlined /></IconButton>
            </Box>
            <Box className='p-1'>
              {errorMessages.map((item, index) => (
                <Box className='mb-2'>
                  <Typography fontWeight='bold' variant='h6'>{item.username}</Typography>
                  <ul className='pl-2'>
                    {item.messages.map((msg) => (
                      <li><Typography variant='subtitle2'>{msg}</Typography></li>
                    ))}
                  </ul>
                </Box>
              ))}
            </Box>
          </DialogContent>
        </Dialog>)}

    </div>
  )
}

export default InviteShopper
